import React from "react";

import { Form, Icon, Option, Select } from "components";

export const FieldVerificationForm = ({ verified, name, onChange, disabled }) => (
  <Form name={name}>
    <Select name="verification-status" disabled={disabled} initialValue={verified} onChange={onChange} className="verification-select">
      <Option value={true}>
        <span className="paragraph-m approved">
          <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
          approved
        </span>
      </Option>
      <Option value={false}>
        <span className="paragraph-m rejected">
          <Icon iconName="tabler/circle-x" size="s" className="icon inline margin-right-25" />
          rejected
        </span>
      </Option>
      <Option value={null}>
        <span className="paragraph-m">
          <Icon iconName="tabler/help" size="s" className="icon inline margin-right-25" />
          not verified
        </span>
      </Option>
    </Select>
  </Form>
);
